import ProvenienzeTable from './ProvenienzeTable';
export default ProvenienzeTable;